export const environment = {
  production: true,
  buildId: '2544751654517661',
  configFile: 'config.json',
};
